import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  DarkTheme,
  DefaultTheme,
  ThemeProvider,
} from "@react-navigation/native";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Stack, useRouter, useSegments } from "expo-router";
import { useEffect, useState } from "react";
import { ActivityIndicator, Appearance, useColorScheme, View } from "react-native";
import { AuthProvider, useAuth } from "../contexts/AuthContext";

const queryClient = new QueryClient();
const THEME_STORAGE_KEY = "app_theme";

function RouteGuard() {
  const { user, isLoading } = useAuth();
  const segments = useSegments();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) return;

    const currentSegment = segments[0] as string | undefined;
    const isAtLogin = currentSegment === "login";

    if (!user && !isAtLogin) {
      // Forçar redirecionamento para login
      router.replace("/login" as any);
    } else if (user && isAtLogin) {
      // Se já estiver logado e tentar ir para login, manda de volta para index
      router.replace("/" as any);
    }
  }, [user, isLoading, segments]);

  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color="#2563eb" />
      </View>
    );
  }

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="login" options={{ headerShown: false }} />
      <Stack.Screen
        name="configuracoes"
        options={{ title: "Configurações", headerShown: true }}
      />
      <Stack.Screen
        name="nova-venda"
        options={{ title: "Nova Comanda", headerShown: true }}
      />
      <Stack.Screen
        name="produtos"
        options={{ title: "Gestão de Produtos", headerShown: true }}
      />
    </Stack>
  );
}

export default function LayoutRaiz() {
  const systemScheme = useColorScheme();
  const [theme, setTheme] = useState<"light" | "dark" | null>(
    systemScheme === "dark" ? "dark" : "light",
  );

  useEffect(() => {
    async function carregarTemaSalvo() {
      try {
        const temaSalvo = await AsyncStorage.getItem(THEME_STORAGE_KEY);

        if (temaSalvo === "light" || temaSalvo === "dark") {
          setTheme(temaSalvo);
          Appearance.setColorScheme(temaSalvo);
        } else {
          setTheme(systemScheme === "dark" ? "dark" : "light");
        }
      } catch (error) {
        console.warn("Erro ao carregar tema salvo:", error);
      }
    }

    carregarTemaSalvo();
  }, [systemScheme]);

  const navigationTheme = theme === "dark" ? DarkTheme : DefaultTheme;

  return (
    <ThemeProvider value={navigationTheme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouteGuard />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
